import React from "react";
import { useSelector } from "react-redux";
import { ChatState } from "../../../context/ChatProvider.js";

function ChatListItem({ chat, getChatSender, formatTimestamp, isOnline, onChatItemClick }) {
  const { selectedChat, setSelectedChat } = ChatState();
  const user = useSelector((state) => state.user);

  const isSelected = chat?._id === selectedChat?._id;
  const sender = getChatSender(user, chat?.users);

  return (
    <div
      onClick={() => { setSelectedChat(chat); onChatItemClick(chat); }}
      className={`tw-mx-3 tw-my-1 tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-px-3 tw-py-2.5 tw-cursor-pointer tw-transition-all ${
        isSelected ? "tw-bg-[#712CB0]/30 tw-border tw-border-[#712CB0]/40" : "tw-bg-white/5 tw-border tw-border-white/0 hover:tw-bg-white/10 hover:tw-border-white/10"
      }`}
    >
      <div className="tw-relative tw-flex-shrink-0">
        <img
          className="tw-h-10 tw-w-10 tw-rounded-lg tw-object-cover"
          src={sender?.avatar}
          alt="profile"
        />
        {isOnline && (
          <span className="tw-absolute tw-right-0 tw-top-0 tw-h-2.5 tw-w-2.5 tw-rounded-full tw-border-2 tw-border-[#280D41] tw-bg-green-400" />
        )}
        <span className="tw-absolute tw-inset-x-0 tw-bottom-0 tw-rounded-b-lg tw-bg-black/50 tw-text-center tw-text-[8px] tw-text-white tw-leading-tight tw-py-0.5">
          {sender?.type}
        </span>
      </div>

      <div className="tw-flex-1 tw-min-w-0">
        <p className="tw-truncate tw-text-sm tw-font-medium tw-text-white tw-m-0">{sender?.name}</p>
      </div>

      <span className="tw-flex-shrink-0 tw-text-xs tw-text-white/30">{formatTimestamp(chat?.updatedAt)}</span>
    </div>
  );
}

export default ChatListItem;
